import { RootState } from "@/Redux/configureStore";
import { loadWidgetCriteria, loadWidgetGroup, setDashboardBasicData, setWidgetCriteria, setWidgetGroup } from "@/Redux/Ducks/dashboardSlice";
import { toggleLoader } from "@/Redux/Ducks/loaderSlice";
import { setGlobalMessage } from "@/Redux/Ducks/messageSlice";
import { EObjectType, setActiveTab, setTabConfig } from "@/Redux/Ducks/tabSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select } from "redux-saga/effects";
import { requestGetDashboardBasicData, requestLoadWidgetCriteria, requestLoadWidgetGroup, requestSaveUserLayout } from "../Requests/dashboard";

export function* handleGetDashboardBasicData(): any {

  try {
    yield put(toggleLoader(true));

    let response: any = yield call(requestGetDashboardBasicData);
    yield put(setDashboardBasicData({ ...response }));

    let widgetGroups = response.widgetGroups;

    if (widgetGroups.length >= 1) {
      yield put(loadWidgetCriteria(widgetGroups[0].widgetgroupno))
    }
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }

}

export function* handleLoadWidgetGroup({ payload }: PayloadAction<string>): any {
  try {
    yield put(toggleLoader(true));

    const object = yield select((state: RootState) => state.Dashboard.activeWidget);
    const modelValue = object.modelValue;

    let response: any = yield call(requestLoadWidgetGroup, payload, modelValue);
    yield put(setWidgetGroup({ ...response }));
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleLoadWidgetCriteria({ payload }: PayloadAction<string>): any {
  try {
    yield put(toggleLoader(true));

    let tabKey = payload;
    let tabIndex = 1;
    let url = "/Dashboard";

    let response: any = yield call(requestLoadWidgetCriteria, payload);
    yield put(setWidgetCriteria({ ...response }));

    const activeWidget = yield select((state: RootState) => state.Dashboard.activeWidget.widgetgroupno);
    yield put(loadWidgetGroup(activeWidget))

    yield put(setTabConfig({ tabActualKey: tabKey, tabIndex, tabKey, url, name: "Dashboard", objectType: EObjectType.Dashboard, hidden: true }));
    yield put(setActiveTab(tabKey));
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
  finally {
    yield put(toggleLoader(false));
  }
}

export function* handleSaveUserDashboardLayout({ payload }: PayloadAction<{ widgetgroupno: string, layout: JSON, insightarea: string }>): any {
  try {
    yield call(requestSaveUserLayout, payload.widgetgroupno, payload.layout, payload.insightarea);
  }
  catch (error: any) {
    yield put(setGlobalMessage({ error }));
  }
}